"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentalPinStatus = void 0;
var ParentalPinStatus;
(function (ParentalPinStatus) {
    ParentalPinStatus["NotSet"] = "notSet";
    ParentalPinStatus["Active"] = "active";
    ParentalPinStatus["Locked"] = "locked";
})(ParentalPinStatus = exports.ParentalPinStatus || (exports.ParentalPinStatus = {}));
